<div
  class="astral-toggle"
  [class.astral-toggle--disabled]="resolvedDisabled"
  [class.astral-toggle--focused]="isFocused"
  [class.astral-toggle--invalid]="resolvedInvalid"
  [class.astral-toggle--readonly]="resolvedReadonly"
>
  <div class="astral-toggle__layout">
    @if (resolvedHelpText) {
      <astral-popover class="astral-toggle__help" [helpText]="resolvedHelpText" [contentId]="helpId" [inline]="true"></astral-popover>
    }

    <label class="astral-toggle__label" [attr.for]="resolvedInputId" (click)="handleLabelClick($event)">
      @if (showCaption) {
        <span class="astral-toggle__content">
          <span class="astral-toggle__caption">{{ resolvedLabel | translate }}</span>
        </span>
      }

      <span class="astral-toggle__switch">
        <input
          #input
          astralFieldAccessibility
          [astralFieldControl]="control"
          [astralFieldHelpText]="helpText"
          [astralFieldInputId]="resolvedInputId"
          class="astral-toggle__native"
          type="checkbox"
          role="switch"
          [formControl]="control"
          [attr.id]="resolvedInputId"
          [attr.name]="resolvedInputName"
          (blur)="handleBlur()"
          (change)="handleChange($event)"
          (click)="handleClick($event)"
          (focus)="handleFocus()"
        />
        <span class="astral-toggle__track" aria-hidden="true"></span>
      </span>
    </label>

  </div>

  @if (resolvedInvalid && resolvedErrorMessage) {
    <div class="astral-toggle__error" [attr.id]="errorId" role="alert">
      {{ resolvedErrorMessage.message | translate: resolvedErrorMessage.params }}
    </div>
  }
</div>
